//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { iosInput } from '@/tools/index.js'
import { mapGetters } from 'vuex'
import vote from '@/mixins/vote'
import rulePlaceholder from '../mixins/rulePlaceholder'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [vote, rulePlaceholder, downloadImgs],
  data() {
    return {
      currentValue: [],
      rule: {
        custom: {
          checkboxValue: {
            required: () => '请选择一个选项',
          },
        },
      },
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.question.options.forEach((item, index) => {
      item.isShowBlank = false
      if (item.blankVisible) {
        item.name = `inputValue${index}`
        item.value = ''
      }
    })
    // 设置投票， 在 mixins 中
    this.mountedVote()
  },
  mounted() {
    const rule = {
      required: () => '请输入内容',
    }
    this.blankOption.forEach((item) => {
      this.rule.custom[item.name] = rule
    })
    console.log(this.rule)
    this.$validator.localize('zh_CN', this.rule)
    //已答的题挂上答案
    if (this.question.v_answer) {
      //选中选项
      this.currentValue = this.question.v_answer.currentValue || []
      // 其他选项的文字
      const checkedOptions = this.question.v_answer.options || []
      checkedOptions.forEach((item) => {
        this.question.options.forEach((o) => {
          if (
            o.blankVisible &&
            item.tenantId == o.tenantId &&
            item.text != o.text
          ) {
            o.value = item.text
          }
        })
      })
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
    // 有输入框的选项
    blankOption() {
      return this.question.options.filter((item) => {
        return item.blankVisible
      })
    },
  },
  watch: {
    async currentValue(n, o) {
      this.question.options.forEach((item) => {
        item.isShowBlank = false
      })
      const param = {
        index: this.index,
        v_answered: !!n.length,
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer,
        })
        // 取消回调
        this.$emit('onSelectCancel')
        return
      }
      for (let id of n) {
        // 判断选择的选项带不带输入框
        let checkedOption = this.blankOption.find((item) => {
          return item.tenantId == id
        })
        // 带input的输入框被选中
        if (checkedOption) {
          this.$set(checkedOption, 'isShowBlank', true)
          // 校验输入框是否必填
          let check = await this.$validator.validateAll({
            [checkedOption.name]: checkedOption.value,
          })
          console.log(check)
          if (check) {
            v_answer = this.getValue()
          }
        } else {
          v_answer = this.getValue()
        }
      }
      console.log(v_answer)
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer,
      })
      //选中回调 把当前选中的选项传给父组件判断子题是否显示
      this.$emit('onSelectChange')
    },
  },
  methods: {
    validateNumber(option) {
      return (
        option.blankMaxLengthVisible &&
        Number(option.applyNumber || 0) >= Number(option.blankMaxLength || 0)
      )
    },
    formatList(list) {
      let start = list[0]
      let end = list[1]
      return `${start}-${end}`
    },
    getCheckboxValidate(question) {
      var rules = []
      if (question.required) {
        rules.push('required')
      }
      if (question.selectRangeMin) {
        rules.push(
          `selectRangeMin:${question.selectRangeMin},${question.selectRangeMax}`
        )
      }
      if (question.selectRangeMax) {
        rules.push(
          `selectRangeMax:${question.selectRangeMin},${question.selectRangeMax}`
        )
      }
      console.log(rules.join('|'))
      return rules.join('|')
    },
    onBlur() {
      iosInput()
    },
    getValidateRule(item) {
      var rules = []
      if (item.blankRequired) {
        rules.push('required')
      }
      if (item.blankMaxLength) {
        rules.push(`max:${item.blankMaxLength}`)
      }
      if (item.blankRule !== 'ignore') {
        if (item.blankRule === 'number') {
          rules.push(`number`)
          rules.push(
            `between:${item.blankMinLength || 0},${
              item.blankMaxLength || 99999
            }`
          )
        } else {
          rules.push(`${item.blankRule}`)
        }
      }
      console.log(rules.join('|'))
      return rules.join('|')
    },
    getValue() {
      const options = []
      this.currentValue.forEach((currentId) => {
        let checkedOption = this.question.options.find((item) => {
          return item.tenantId == currentId
        })
        options.push({
          tenantId: checkedOption.tenantId,
          text: checkedOption.value ? checkedOption.value : '', // checkedOption.text
        })
      })
      return {
        tenantId: this.question.tenantId,
        type: 'activity_time',
        options: options,
        currentValue: this.currentValue,
      }
    },
    validate() {
      return this.$validator
        .validateAll({
          checkboxValue: this.currentValue,
        })
        .then(async (check) => {
          if (check) {
            // 如果有文本框的选项被选中，验证文本框是否填写
            let promiseArray = []
            for (const k of this.currentValue) {
              let checkedOption = this.blankOption.find((item) => {
                return item.tenantId == k
              })
              if (checkedOption) {
                const validate = this.$validator.validateAll({
                  [checkedOption.name]: checkedOption.value,
                })
                promiseArray.push(validate)
              }
            }
            const checkList = await Promise.all(promiseArray)
            return checkList.every((item) => {
              return item
            })
          } else {
            return false
          }
        })
    },
    onInputChange(item) {
      // 如果当前输入框被选中则挂答案
      if (this.currentValue.includes(item.tenantId)) {
        let v_answer = this.getValue()
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer,
        })
      }
      console.log(this.question)
    },
  },
}
